import { Chip } from '@mui/material';
import { PerformerRequestStatus } from '@silbo/core';
import { ArrowCircleIcon, ErrorCircleIcon, HourglassIcon, PatientReadyIcon } from '@silbo/ui';
import { useTranslation } from 'react-i18next';

const RequestStatusChip = ({ status }: { status: PerformerRequestStatus }) => {
  const { t } = useTranslation('bed-management');

  if (status === 'REVOKED') {
    return null;
  }

  return (
    <Chip label={t(`requestStatus.${status}`)} icon={ChipIcon[status]} color={chipColor[status]} variant="light" />
  );
};

type DisplayedStatus = Exclude<PerformerRequestStatus, 'REVOKED'>;

const ChipIcon: Record<DisplayedStatus, React.ReactElement> = {
  REQUESTED: <HourglassIcon />,
  ACCEPTED: <PatientReadyIcon />,
  REJECTED: <ErrorCircleIcon />,
  REROUTED: <ArrowCircleIcon />,
};

const chipColor: Record<DisplayedStatus, 'warning' | 'error' | 'primary' | 'default'> = {
  REQUESTED: 'primary',
  ACCEPTED: 'warning',
  REJECTED: 'error',
  REROUTED: 'default',
};

export default RequestStatusChip;
